'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Textarea = exports.Textarea = (0, _systemComponents2.default)({
  is: 'textarea',
  px: 1,
  py: 2,
  m: 0,
  width: 1,
  fontSize: 'inherit',
  color: 'inherit',
  bg: 'transparent',
  border: 0,
  borderColor: 'gray',
  boxShadow: 1,
  borderRadius: 2
}, function (props) {
  return {
    fontFamily: 'inherit',
    appearance: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'inset 0 0 0 1px' + (0, _styledSystem.themeGet)('colors.blue')(props)
    },
    '&:disabled': {
      opacity: 1 / 4
    }
  };
});

Textarea.displayName = 'Textarea';

exports.default = Textarea;